import { render, staticRenderFns } from "./tenderOfferReturn.vue?vue&type=template&id=1f9a52a6&scoped=true&"
import script from "./tenderOfferReturn.vue?vue&type=script&lang=js&"
export * from "./tenderOfferReturn.vue?vue&type=script&lang=js&"
import style0 from "./tenderOfferReturn.vue?vue&type=style&index=0&id=1f9a52a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9a52a6",
  null
  
)

export default component.exports